import { Box, Container, Divider, Grid, Link, Typography } from '@material-ui/core';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LogoStackedNegative } from '../../../../elements/Branding/LogoStackedNegative';
import { BusinessRoutes, WebRoutes } from '../../../../enums/routerPath';
import FCMLogo from '../../../../static/images/marketing/FCMLogo.png';
import useStyles from './footer.styles';

export const CustomerFooter: React.FC = () => {
	const styles = useStyles();
	return (
		<Container className={styles.root} maxWidth={false} disableGutters>
			<Container maxWidth="lg">
				<Grid container alignItems="center" justifyContent="space-evenly" spacing={2}>
					<Grid item className={styles.logo}>
						<LogoStackedNegative />
					</Grid>
					<Grid className={styles.contact} item>
						<Typography component="span">SMS us:</Typography>
						<Link color="inherit" underline="none" href={window.config.REACT_APP_CONTACT_MOBILE_HREF}>
							{window.config.REACT_APP_CONTACT_MOBILE}
						</Link>
					</Grid>
					<Grid className={styles.contact} item>
						<Typography component="span">Call us:</Typography>
						<Link color="inherit" underline="none" href={window.config.REACT_APP_CONTACT_NUMBER_HREF}>
							{window.config.REACT_APP_CONTACT_NUMBER}
						</Link>
					</Grid>
					<Grid className={styles.contact} item>
						<Typography component="span">Email us:</Typography>
						<Link color="inherit" underline="none" href={`mailto:${window.config.REACT_APP_CONTACT_EMAIL}`}>
							{window.config.REACT_APP_CONTACT_EMAIL}
						</Link>
					</Grid>
					<Grid className={styles.contact} item>
						<Typography component="span">Address:</Typography>
						<Typography component="span">Level 6, 15 William Street, Melbourne VIC 3000.</Typography>
					</Grid>
				</Grid>
				<Divider />
				<Grid className={styles.footerLinks} container alignItems="center">
					<Grid item>
						<Link className={styles.navLink} color="inherit" component={RouterLink} to={WebRoutes.HOW_IT_WORKS.path} underline="none">
							How it Works
						</Link>
					</Grid>
					<Grid item>
						<Link className={styles.navLink} color="inherit" component={RouterLink} to={WebRoutes.SUPPORT.path} underline="none">
							Help
						</Link>
					</Grid>
					<Grid item>
						<Link className={styles.navLink} color="inherit" component={RouterLink} to={WebRoutes.ABOUT.path} underline="none">
							About Us
						</Link>
					</Grid>
					<Grid item>
						<Link className={styles.navLink} color="inherit" component={RouterLink} to={WebRoutes.CONTACT.path} underline="none">
							Contact
						</Link>
					</Grid>
					<Grid item>
						<Link className={styles.navLink} color="inherit" component={RouterLink} to={WebRoutes.PRIVACY.path} underline="none">
							Privacy Policy
						</Link>
					</Grid>
					<Grid item>
						<Link className={styles.navLink} color="inherit" component={RouterLink} to={WebRoutes.TERMS.path} underline="none">
							Terms of Service
						</Link>
					</Grid>
					<Grid item>
						<Link className={styles.navLink} color="inherit" href="https://francomgroup.com/" underline="none">
							Corporate site
						</Link>
					</Grid>
					<Grid className={styles.grow} />
					<Grid item>
						<Link className={styles.navLink} color="inherit" component={RouterLink} to={BusinessRoutes.HOME.path} underline="none">
							For Business
						</Link>
					</Grid>
				</Grid>
				<Divider />
				<Grid container alignItems="center" spacing={3}>
					<Grid item xs={5}>
						<Box>
							<Link href="https://francomgroup.com" target="_blank">
								<div className={styles.fcmLogo} style={{ backgroundImage: `url(${FCMLogo})` }} />
							</Link>
						</Box>
					</Grid>
					<Grid item xs={6}>
						<Typography className={styles.copyright} component="p" variant="caption">
							{`© ${new Date().getFullYear()} ${window.config.REACT_APP_COMPANY_FULL}`}
						</Typography>
					</Grid>
				</Grid>
			</Container>
		</Container>
	);
};
